import React, { useMemo } from "react";

import { HttpError } from "../../../elements/HttpError/HttpError";

import "./E404.scss";

const pageE404MessagesCount = 16;
const pickPageE404Desc = _=>`pageE404Msg${Math.floor(Math.random() * pageE404MessagesCount) + 1}`;

export const E404 = _=>{
    const desc = useMemo(pickPageE404Desc, []);

    return (
        <HttpError
            action="pageE404Action"
            caption="pageE404Caption"
            className="E404"
            desc={desc}
            status="404"
        />
    );
};
